@if (image) {
  <div
    [style.backgroundColor]="backgroundColor | contentBuilderColor"
    class="w-full"
  >
    <div
      [ngClass]="{
        'container mx-auto max-w-640 pb-5': useContainer,
      }"
    >
      @if (property === 'percent') {
        <img
          [src]="image.url"
          [style.width.%]="width"
          class="mx-auto max-w-full"
        />
      }
      @if (property === 'pixel') {
        <img
          [src]="image.url"
          [style.width.px]="width"
          class="mx-auto max-w-full"
        />
      }
    </div>
  </div>
}
